// @module Convergence.TopDealsExt.TopDealsExt
define('Convergence.featuredProd.featuredProd.ItemCell.View'
    ,	[
        'featuredProd_itemcell.tpl'
        ,	'Backbone'
        ,   'Facets.ItemCell.View'
        ,   'Product.Model'
        ,   'Convergence.featuredProd.featuredProd.QuickAddtoCart.View'
        ,   'underscore'
        ]
    , function (
        featuredProd_itemcell_tpl
        ,	Backbone
        ,   FacetsItemCellView
        ,   ProductModel
        ,   CartQuickAddToCartView
        ,   _
    )
    {
        'use strict';
    
        // @class Convergence.TopDealsExt.TopDealsExt.View @extends Backbone.View
        return FacetsItemCellView.extend({
    
            template: featuredProd_itemcell_tpl
    
        ,	initialize: function (options) {
            FacetsItemCellView.prototype.initialize.apply(this, arguments);
                this.model = options.model;
            }
       
        ,	events: {
            }
    
        ,	bindings: {
            }
    
        , 	childViews:  _.extend({},FacetsItemCellView.prototype.childViews, {
                'Cart.QuickAddToCart.new': function() {
                    const product = new ProductModel({
                        item: this.model,
                        quantity: this.model.get('_minimumQuantity', true)
                    });
    
                    return new CartQuickAddToCartView({
                        model: product,
                        application: this.options.application
                    });
                },
            })
    
        ,   getCategoryName: function ()
            {
                var commerceCategory = this.model.get('commercecategory') || {};
                var categories = commerceCategory.categories || [];
                var primaryPath = commerceCategory.primarypath || [];

                // Generic names that are NOT product types
                var blacklistedNames = [
                    'shop by brand',
                    'shop by category',
                    'shop-by-brand',
                    'shop-by-category',
                    'brand',
                    'brands',
                    'all categories',
                    'home'
                ];

                function isRootBrandCategory(cat) {
                    if (!cat) {
                        return false;
                    }
                    var urls = cat.urls || [];
                    return _.some(urls, function (u) {
                        var cleanUrl = (u || '').toLowerCase().replace(/^\/|\/$/g, '');
                        var segments = cleanUrl.split('/');
                        return (segments[0] === 'shop_by_brand' || segments[0] === 'shop-by-brand') && segments.length <= 2;
                    });
                }

                // 1. If primarypath[0] is a product category (under /shop-by-category/ or deeper subcategory), use it
                if (primaryPath.length > 0) {
                    var prim = primaryPath[0];
                    var primName = (prim.name || '').trim();
                    if (!_.contains(blacklistedNames, primName.toLowerCase()) && !isRootBrandCategory(prim)) {
                        return primName;
                    }
                }

                // 2. Search all categories for the most specific product category
                var allCatEntries = [];

                function addCategory(cat, isPrimary) {
                    if (!cat || !cat.name) {
                        return;
                    }
                    var name = (cat.name || '').trim();
                    if (_.contains(blacklistedNames, name.toLowerCase())) {
                        return;
                    }

                    var urls = cat.urls || [];
                    if (urls.length === 0) {
                        allCatEntries.push({
                            name: name,
                            score: isPrimary ? 5 : 1,
                            isRootBrand: false,
                            depth: 1
                        });
                        return;
                    }

                    _.each(urls, function (u) {
                        if (!u) {
                            return;
                        }
                        var cleanUrl = u.toLowerCase().replace(/^\/|\/$/g, '');
                        var segments = cleanUrl.split('/');

                        var isRootBrand = (segments[0] === 'shop_by_brand' || segments[0] === 'shop-by-brand') && segments.length <= 2;
                        var isShopByCat = (segments[0] === 'shop-by-category' || segments[0] === 'shop_by_category') && segments.length > 1;

                        var score = segments.length;
                        if (isShopByCat) {
                            score += 20; // High priority for shop-by-category
                        }
                        if (isPrimary && !isRootBrand) {
                            score += 10;
                        }
                        if (isRootBrand) {
                            score -= 50; // Ignore root brands
                        }

                        allCatEntries.push({
                            name: name,
                            score: score,
                            isRootBrand: isRootBrand,
                            depth: segments.length
                        });
                    });
                }

                _.each(primaryPath, function(c) { addCategory(c, true); });
                _.each(categories, function(c) { addCategory(c, false); });

                // 1. Highest priority: Non-brand specific product categories
                var validEntries = _.filter(allCatEntries, function (e) {
                    return !e.isRootBrand && e.score > 0;
                });
                if (validEntries.length > 0) {
                    validEntries.sort(function (a, b) {
                        return b.score - a.score;
                    });
                    return validEntries[0].name;
                }

                // 2. Second priority: Subcategories under brand (depth > 2)
                var brandSubEntries = _.filter(allCatEntries, function (e) {
                    return e.depth > 2 && e.score > -20;
                });
                if (brandSubEntries.length > 0) {
                    brandSubEntries.sort(function (a, b) {
                        return b.score - a.score;
                    });
                    return brandSubEntries[0].name;
                }

                // 3. Fallback: Direct item attributes
                return this.model.get('custitem_product_type') ||
                       this.model.get('custitem_producttype') ||
                       this.model.get('custitem_category') ||
                       this.model.get('class') ||
                       '';
            }

            //@method getContext @return Convergence.TopDealsExt.TopDealsExt.View.Context
        ,	getContext: function getContext()
            {
                //@class Convergence.TopDealsExt.TopDealsExt.View.Context
                var product = new ProductModel({
                    item: this.model
                });
                
                return {
                    itemId: this.model.get('_id'),
                    // @property {String} name
                    name: this.model.get('_name'),
                    // @property {String} url
                    url: this.model.get('_url'),
                    // @property {String} sku
                    sku: this.model.getSku(),
                    // @property {String} categoryName
                    categoryName: this.getCategoryName(),
                    // @property {Boolean} isEnvironmentBrowser
                    isEnvironmentBrowser:
                        SC.ENVIRONMENT.jsEnvironment === 'browser' && !SC.ENVIRONMENT.isTouchEnabled,
                    // @property {ImageContainer} thumbnail
                    thumbnail: this.model.getThumbnail(),
                    // @property {Boolean} itemIsNavigable
                    itemIsNavigable: !_.isUndefined(this.options.itemIsNavigable)
                        ? !!this.options.itemIsNavigable
                        : true,
                    // @property {Boolean} showRating
                    showRating: SC.ENVIRONMENT.REVIEWS_CONFIG && SC.ENVIRONMENT.REVIEWS_CONFIG.enabled,
                    // @property {Number} rating
                    rating: this.model.get('_rating'),
                    // @property {String} track_productlist_list
                    track_productlist_list: this.model.get('track_productlist_list'),
                    // @property {String} track_productlist_position
                    track_productlist_position: this.model.get('track_productlist_position'),
                    // @property {String} track_productlist_category
                    track_productlist_category: this.model.get('track_productlist_category')
                };
            }
        });
    });
    
